// TSS vite/03 §"Query keys convention".
// Tuples, entity name first, scope narrowing rightward.

export const userKeys = {
    all:    ['users'],
    list:   (params) => ['users', 'list', params],
    detail: (id)     => ['users', 'detail', id],
    // Keyed by (user, page): the route paginates, so two pages of the same
    // person's memberships are two different answers.
    teams:  (id, params) => ['users', 'teams', String(id), params],
};
